import { render, staticRenderFns } from "./ItemListAndComponent.vue?vue&type=template&id=5d72cf27&"
import script from "./ItemListAndComponent.vue?vue&type=script&lang=js&"
export * from "./ItemListAndComponent.vue?vue&type=script&lang=js&"
import style0 from "./ItemListAndComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports